
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.438 9.5a1.313 1.313 0 100 2.625 1.313 1.313 0 000-2.625zm-1.313 3.938v14.437h2.625V13.437h-2.625zm5.25 0v14.437h5.906c3.971 0 7.219-3.248 7.219-7.219 0-3.97-3.248-7.218-7.219-7.218h-5.906zM20 16.061h3.281a4.575 4.575 0 014.594 4.594 4.575 4.575 0 01-4.594 4.594H20v-9.188z","fill":"currentColor"}})])
          )
        }
      }
    